// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"cb614cd4cfa5f48c","6831":"e54e057ac96dbe86","8503":"ffc84d5bb969480e","9683":"0e2ccfbc057d66a0"}[chunkId] + ".js";
};